import { render } from "./ElectronicMonitoring.vue?vue&type=template&id=1aa3b236&ts=true"
import script from "./ElectronicMonitoring.vue?vue&type=script&lang=ts"
export * from "./ElectronicMonitoring.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__